import React, { ReactNode } from "react";

import _ from "lodash";
import cx from "classnames";

import LinesEllipsis from "react-lines-ellipsis";
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC'

import useMeasure from "react-use-measure";

import styles from './text.module.scss';
import Tooltip from "../tooltip";
import { Placement } from "react-bootstrap/esm/types";

const ResponsiveEllipsis = responsiveHOC()(LinesEllipsis)


interface TextProps {
  text?: string;
  width?: number;
  lines?: number;
  className?: string;
  tooltip?: TooltipProps | boolean;
}

interface TooltipProps {
  placement: Placement;
}

const Text: React.FC<TextProps> = ({ text, lines = 1, className, tooltip = true }) => {
  const [textRef, textBounds] = useMeasure();
  const [initialised, setInitialized] = React.useState(false);
  const [clamped, setClamped] = React.useState(false);

  const tooltipProps = React.useMemo<TooltipProps>(() => {
    if (tooltip === true) {
      return {
        placement: "top",
      };
    } else if (tooltip && typeof tooltip === "object") {
      return tooltip;
    }

    return {
      placement: "top",
    };
  }, [tooltip]);

  React.useEffect(() => {
    if (textBounds.width > 0) {
      setInitialized(true);
    }
  }, [textBounds]);

  return (
    <div className={cx(styles.text, className)} ref={textRef}>
      {initialised && (
        <Tooltip disabled={!tooltip || !clamped} content={text || ""} placement={tooltipProps.placement}>
          <ResponsiveEllipsis className={cx(styles.truncate, className)}
            maxLine={lines}
            text={text}
            style={{ width: textBounds.width, wordBreak: "break-word" }}
            ellipsis="..."
            trimRight
            basedOn="letters"
            onReflow={({ clamped }) => {
              setClamped(clamped);
            }}
          />
        </Tooltip>
      )}
    </div>
  );
};

export default React.memo(Text);
